<template>
  <div>
    <!-- 增值服务 {{id}} {{type}} -->
    <div class="content-header">
      <div class="left">
        <span class="title">应用购买</span>
      </div>
      <div class="right"></div>
    </div>
    <div class="pageTitle" v-if="agent.tp == 0 || agent.is_activation">
      云知印运营期<span style="color: red; font-size: 12px">
        （仅适用于设备类型为云知印的设备）</span
      >
    </div>
    <div class="itembox" v-if="agent.tp == 0 || agent.is_activation">
      <!--  @click="selectType(0)" -->
      <div
        class="item"
        @mouseover="itemStyle1 = 'border: 1px solid #D40000;'"
        @mouseout="itemStyle1 = ''"
        :style="itemStyle1"
        @click="selectType(1)"
      >
        <div class="iconfont_box">
          <span class="iconfont">&#xe664;</span>
        </div>
        <div class="r_box">
          <div class="titbox">
            <p class="tit">运营期延续</p>
          </div>
          <div class="des">
            仅适用于安装了云知印通用基础版或服务窗口版的设备，对其运营期进行延续
          </div>
        </div>
      </div>

      <!-- <div class="item" @mouseover="itemStyle1 = 'border: 1px solid #D40000;'" @mouseout="itemStyle1 = ''"
        :style="itemStyle1" @click="selectType(9)">
        <div class="iconfont_box">
          <span class="iconfont">&#xe664;</span>
        </div>
        <div class="r_box">
          <div class="titbox">
            <p class="tit">账户充值</p>
          </div>
          <div class="des">
            该账户余额用于文档审核等增值服务，充值后可使用
          </div>
        </div>
      </div> -->
    </div>
    <div class="pageTitle">营销推广</div>
    <div class="itembox">
      <div
        class="item"
        @click="selectType(2)"
        @mouseover="itemStyle2 = 'border: 1px solid #D40000;'"
        @mouseout="itemStyle2 = ''"
        :style="itemStyle2"
      >
        <div class="iconfont_box">
          <span class="iconfont">&#xe666;</span>
        </div>
        <div class="r_box">
          <div class="titbox">
            <p class="tit">刷卡验证功能</p>
            <p class="money">¥ 500</p>
          </div>
          <div class="des">
            用于会员在设备端刷卡登录，代替帐号和密码
            <span style="color: red">(含IC读卡器)</span>
          </div>
        </div>
      </div>
      <div
        class="item"
        @click="selectType(3)"
        @mouseover="itemStyle3 = 'border: 1px solid #D40000;'"
        @mouseout="itemStyle3 = ''"
        :style="itemStyle3"
      >
        <div class="iconfont_box">
          <span class="iconfont">&#xe665;</span>
        </div>
        <div class="r_box">
          <div class="titbox">
            <p class="tit">身份证读取输出功能</p>
            <p class="money">¥ 500</p>
          </div>
          <div class="des">
            将身份证靠近阅读器，即可自动将证件正反两面1：1复印在纸张的同一面，支持二代、三代身份证读取和鉴别
            <span style="color: red">(不含身份证阅读器硬件)</span>
          </div>
        </div>
      </div>
    </div>
    <div class="itembox">
      <div
        class="item"
        @mouseover="itemStyle5 = 'border: 1px solid #D40000;'"
        @mouseout="itemStyle5 = ''"
        :style="itemStyle5"
        @click="selectType(5)"
      >
        <div class="iconfont_box">
          <!-- <span class="iconfont">&#xe66e;</span> -->
          <img style="width: 60px; height: 60px" src="../../assets/images/ic_face.png" />
        </div>
        <div class="r_box">
          <div class="titbox">
            <p class="tit">面容认证</p>
            <p class="money">¥ 1200</p>
          </div>
          <div class="des">
            会员在设备端可通过人脸识别登录会员账户，方便、快捷、安全
            <span style="color: red">（不含摄像头硬件）</span>
          </div>
        </div>
      </div>
      <div
        class="item"
        @mouseover="itemStyle8 = 'border: 1px solid #D40000;'"
        @mouseout="itemStyle8 = ''"
        :style="itemStyle8"
        @click="selectType(8)"
      >
        <div class="iconfont_box">
          <!-- <span class="iconfont">&#xe66e;</span> -->
          <img style="width: 70px" src="../../assets/images/photo-print.jpg" />
        </div>
        <div class="r_box">
          <div class="titbox">
            <p class="tit">相片冲印</p>
            <p class="money">¥ 800</p>
          </div>
          <div class="des">
            可实现各种规格以及场景证件照的制作冲印，同时可冲印你相册中的精美照片，打开云知印微信小程序可体验证件照制作
            <span style="color: red">（需额外自备一台佳能G5080打印机）</span>
          </div>
        </div>
      </div>
    </div>

    <div class="itembox">
      <div
        class="item"
        @mouseover="itemStyle6 = 'border: 1px solid #D40000;'"
        @mouseout="itemStyle6 = ''"
        :style="itemStyle6"
        @click="showOpenFileCheckModal = true"
      >
        <div class="iconfont_box">
          <img style="width: 60px; height: 60px" src="../../assets/images/ic_face.png" />
        </div>
        <div class="r_box">
          <div class="titbox">
            <p class="tit">文件审核</p>
            <!-- <p class="money">¥ 0.00</p> -->
          </div>
          <div class="des">
            对文件进行打印前的安全审核，拒绝含有色情、暴力、惊悚、敏感、禁限、辱骂等风险内容或元素的文件打印输出
            <!-- <span style="color: red;">（不含摄像头硬件）</span> -->
          </div>
        </div>
      </div>
    </div>

    <div class="pageTitle">智能运维</div>
    <div class="itembox">
      <!--  @click="selectType(0)" -->
      <div
        class="item"
        @mouseover="itemStyle4 = 'border: 1px solid #D40000;'"
        @mouseout="itemStyle4 = ''"
        :style="itemStyle4"
        @click="selectType(4)"
      >
        <div class="iconfont_box">
          <span class="iconfont">&#xe663;</span>
        </div>
        <div class="r_box">
          <div class="titbox">
            <p class="tit">智能运维</p>
          </div>
          <div class="des">
            将传统数码复合机进行智能物联网，从多角度进行运维和管理提高工作效率的同时、优化减少企业人工成本支出
          </div>
        </div>
      </div>
    </div>

    <Modal
      v-model="modalPay.visible"
      :title="modalPay.title"
      :width="840"
      footer-hide
      @on-visible-change="modalPayChange"
    >
      <div class="tips">
        <Icon type="md-alert" size="20" color="#2d8cf0" style="margin-right: 10px" />
        <span>请确保所输入的设备序列号无误，错误操作将无法撤销</span>
        <!-- <span v-if="payType == 5">(只支持通用基础版的设备)</span>
        <span v-if="payType != 3 && payType != 5 && payType != 8"
          >(该功能暂时只支持设备类型为云知印、设备品牌为理光的设备开通)</span
        >
        <span v-if="payType == 3">(只支持服务窗口版的设备)</span>
        <span v-if="payType == 8"
          >(只支持设备类型为云知印的设备、不支持以下型号：MPC2004系列、MP2555SP系列)</span
        > -->
        <span v-if="payType == 2 || payType == 3 || payType == 8 || payType == 5"
          >(该功能暂时只支持设备类型为云知印、设备品牌为理光的设备开通)</span
        >
      </div>
      <div class="modalpay_box" v-if="!modalPay.isPay">
        <div style="margin-top: 10px">
          指定设备：
          <!-- <Select
            v-model="modalPay.data.select_machine"
            multiple
            filterable
            class="select"
            style="width: 300px"
            :placeholder="
              payType == 5
                ? '只支持通用基础版的设备'
                : payType != 3
                ? '只能选择设备类型为云知印的设备'
                : '暂时只支持服务窗口版的设备'
            "
          >
            <Option
              v-for="(item, index) in modalPay.machine"
              :key="index"
              :value="item.id"
              :label="item.sn"
            >
              <span>{{ item.sn }}</span>
              <span style="margin-left: 10px; color: #ccc">{{
                item.site_name
              }}</span>
            </Option>
          </Select> -->
          <!-- <Input style="width: 300px" v-model="machineSn" :placeholder="
            payType == 5
              ? '只支持通用基础版的设备'
              : payType != 3
                ? '只能选择设备类型为云知印的设备'
                : '暂时只支持服务窗口版的设备'
          "></Input> -->
          <Input
            style="width: 300px"
            v-model="machineSn"
            placeholder="请输入设备序列号，然后点击确认"
          ></Input>
          <Button type="primary" style="margin-left: 15px" @click="getMachineInfo"
            >确定</Button
          >
          <!--  <Button
            :type="
              modalPay.data.select_machine.length > 0 ? 'primary' : 'default'
            "
            style="margin-left: 15px"
            @click="addSelectMachine"
            >确定</Button
          > -->
        </div>
        <table class="ivu-table ivu-table-default appoint-table">
          <tr>
            <th>设备序列号</th>
            <th>设备站点</th>
            <th v-if="payType == 1">当前到期时间</th>
            <th style="width: 130px; text-align: center">操作</th>
          </tr>
          <tr v-for="(item, index) in modalPay.data.machine" :key="index">
            <td>
              {{ item.sn }}
            </td>
            <td>
              {{ item.site_name }}
            </td>
            <td v-if="payType == 1">
              {{ $moment(item.expire_time, "YYYY-MM-DD") }}
            </td>
            <td style="width: 130px; text-align: center">
              <span class="del" @click="delMachine(item)">删除</span>
            </td>
          </tr>
        </table>
        <div
          class="btn"
          style="background-color: #ccc"
          v-if="modalPay.data.machine.length == 0"
        >
          下一步
        </div>
        <div class="btn" v-else @click="btnNext">下一步</div>
      </div>

      <div class="pay_content" v-if="modalPay.isPay">
        <div v-if="payType == 1">
          <div class="pageTitle">
            选择延续时长
            <span class="tips2">(运营期可叠加购买)</span>
          </div>
          <RadioGroup
            v-model="pay_period.month"
            style="margin-top: 10px; padding-left: 10px; font-family: lucidasans"
            @on-change="changeMonth"
          >
            <Radio :label="12" style="margin-right: 122px"> 12月</Radio>
            <Radio :label="24" style="margin-right: 110px">24月(7.5折优惠)</Radio>
            <Radio :label="36">36月(6.6折优惠)</Radio>
          </RadioGroup>
          <div>
            <span v-if="pay_period.month == 24" class="coupon" style="margin-left: 205px"
              >¥1800.00元<span style="color: #50ac5c">(省：600.00元)</span></span
            >
            <span v-if="pay_period.month == 36" class="coupon" style="margin-left: 440px"
              >¥2400.00元<span style="color: #50ac5c">(省：1200.00元)</span></span
            >
          </div>
        </div>
        <div class="pageTitle" style="margin-top: 20px">支付方式</div>
        <RadioGroup
          v-model="pay_period.pay_type"
          style="margin-top: 10px; padding-left: 10px; display: flex"
        >
          <!-- <Radio :label="1" style="margin-right: 60px" class="radio">
            <img class="pay_icon" src="../../assets/images/ic_pay2.png" />
          </Radio> -->
          <Radio :label="2" style="margin-right: 60px" class="radio">
            <img style="width: 26px" src="../../assets/images/ic_alipay.png" />支付宝支付
          </Radio>
          <Radio :label="3" class="radio">
            <img class="pay_icon" src="../../assets/images/ic_pay1.png" />
          </Radio>
        </RadioGroup>

        <div class="bankPayBox" v-if="pay_period.pay_type === 3">
          <!-- modal.data.pay_type -->
          <div class="item">
            <p class="tit">开户行：</p>
            <p class="txt">中国建设银行股份有限公司重庆九龙坡科园一路支行</p>
          </div>
          <div class="item">
            <p class="tit">对公账号：</p>
            <p class="txt">5005 0103 0049 0000 3745</p>
          </div>
          <div class="item">
            <p class="tit">开户名：</p>
            <p class="txt">九龙坡区云知印信息技术服务部</p>
          </div>
          <div class="item">
            <p class="tit">转账凭证：</p>
            <div class="voucher_uploadBox">
              <div class="upload" v-if="pay_period.filename.length < 3">
                <p class="t">
                  点击上传
                  <span style="color: #555; font-size: 10px">最多3张</span>
                </p>
                <input
                  type="file"
                  accept="image/png,image/jpeg,image/gif,image/jpg"
                  class="upBtn"
                  @change="chooseImage($event)"
                />
              </div>
              <div>
                <Tag
                  v-for="(item, index) in pay_period.filename"
                  :key="index"
                  closable
                  @on-close="deleteImage(index)"
                >
                  {{ item }}</Tag
                >
              </div>
            </div>
          </div>
        </div>
        <div class="moneyBox">
          总计：<span style="font-size: 20px; color: #2d8cf0"
            ><span style="font-size: 14px">￥</span>{{ pay_period.totalMoney }}
            <span style="font-size: 14px"
              >({{ pay_period.operateMoney.toFixed(2) }} X {{ pay_period.count }}台)</span
            >
          </span>
        </div>
        <!-- <div> -->
        <div class="btn-box">
          <div class="subBtn" v-preventReClick @click="payPeriod">立即支付</div>
          <span
            class="btn2"
            @click="
              modalIdcardAddress = false;
              modalPay.isPay = false;
            "
            >上一步</span
          >
        </div>
        <span
          v-if="pay_period.pay_type === 3"
          style="color: red; font-size: 12px; margin-left: 8px"
          >凭证提交后，我们将尽快审核，审核通过后功能将自动开通</span
        >
        <!-- </div> -->
      </div>

      <Spin fix v-if="showLoadding"></Spin>
    </Modal>

    <Modal
      v-model="modalMeterPay.visible"
      title="智能运维功能"
      :width="1000"
      footer-hide
      @on-visible-change="modalPayChange"
    >
      <div class="tips">
        <Icon type="md-alert" size="20" color="#2d8cf0" style="margin-right: 10px" />
        支付成功后，系统将自动生成所购买套餐中的安全码，请至应用中心>运维安全码页面查看。安全码使用方法请查看相关手册！
      </div>
      <div v-if="!modalMeterPay.isPay">
        <div style="color: #000; font-size: 16px; margin-top: 30px; margin-left: 10px">
          选择套餐
        </div>
        <div class="meter">
          <div
            class="item"
            :class="{ active: modalMeterPay.num == 5 }"
            @click="selectMeter(5)"
          >
            <!-- <Button
              type="primary"
              class="buy_btn"
              size="small"
              @click="meterPrePay(5)"
              >购买</Button
            > -->
            <div class="title">
              智能运维安全码5个，低至<span class="color">2.7</span
              ><span class="color small">元</span><span class="small">/台.月</span>
            </div>
            <ul class="information">
              <li>此套餐包含5个安全码，可激活5台设备</li>
              <li>安全码从购买之日起有效期1年，不退换</li>
              <li>每个安全码激活后运营期为3年，不支持转移运营期</li>
            </ul>
            <div style="display: flex; align-items: center">
              <div class="money">￥500</div>
              <div class="btn">体验套餐</div>
            </div>
          </div>
          <div
            class="item"
            :class="{ active: modalMeterPay.num == 30 }"
            @click="selectMeter(30)"
          >
            <div class="title">
              智能运维安全码30个，低至<span class="color">2.2</span
              ><span class="color small">元</span><span class="small">/台.月</span>
            </div>
            <ul class="information">
              <li>此套餐包含30个安全码，可激活30台设备</li>
              <li>安全码从购买之日起有效期1年，不退换</li>
              <li>每个安全码激活后运营期为3年，不支持转移运营期</li>
            </ul>
            <div style="display: flex; align-items: center">
              <div class="money">￥2400</div>
              <div class="del_money">原价:3000元</div>
              <div class="btn">尊享8折</div>
            </div>
          </div>
          <div
            class="item"
            :class="{ active: modalMeterPay.num == 50 }"
            @click="selectMeter(50)"
          >
            <div class="title">
              智能运维安全码50个，低至<span class="color">1.9</span
              ><span class="color small">元</span><span class="small">/台.月</span>
            </div>
            <ul class="information">
              <li>此套餐包含50个安全码，可激活50台设备</li>
              <li>安全码从购买之日起有效期1年，不退换</li>
              <li>每个安全码激活后运营期为3年，不支持转移运营期</li>
            </ul>
            <div style="display: flex; align-items: center">
              <div class="money">￥3500</div>
              <div class="del_money">原价:5000元</div>
              <div class="btn">尊享7折</div>
            </div>
          </div>
          <div
            class="item"
            :class="{ active: modalMeterPay.num == 100 }"
            @click="selectMeter(100)"
          >
            <div class="title">
              智能运维安全码100个，低至<span class="color">1.3</span
              ><span class="color small">元</span><span class="small">/台.月</span>
            </div>
            <ul class="information">
              <li>此套餐包含500个安全码，可激活500台设备</li>
              <li>安全码从购买之日起有效期1年，不退换</li>
              <li>每个安全码激活后运营期为3年，不支持转移运营期</li>
            </ul>
            <div style="display: flex; align-items: center">
              <div class="money">￥5000</div>
              <div class="del_money">原价:10000元</div>
              <div class="btn">尊享5折</div>
            </div>
          </div>
        </div>
        <Button type="primary" style="width: 120px; margin-left: 10px" @click="nextMeter"
          >下一步</Button
        >
      </div>
      <div class="pay_content" v-if="modalMeterPay.isPay">
        <div class="pageTitle" style="margin-top: 20px">支付方式</div>
        <RadioGroup
          v-model="pay_period.pay_type"
          style="margin-top: 10px; padding-left: 10px; display: flex"
        >
          <!-- <Radio :label="1" style="margin-right: 60px" class="radio">
            <img class="pay_icon" src="../../assets/images/ic_pay2.png" />
          </Radio> -->
          <Radio :label="2" style="margin-right: 60px" class="radio">
            <img style="width: 26px" src="../../assets/images/ic_alipay.png" />支付宝支付
          </Radio>
          <Radio :label="3" class="radio">
            <img class="pay_icon" src="../../assets/images/ic_pay1.png" />
          </Radio>
        </RadioGroup>

        <div class="bankPayBox" v-if="pay_period.pay_type === 3">
          <!-- modal.data.pay_type -->
          <div class="item">
            <p class="tit">开户行：</p>
            <p class="txt">中国建设银行股份有限公司重庆九龙坡科园一路支行</p>
          </div>
          <div class="item">
            <p class="tit">对公账号：</p>
            <p class="txt">5005 0103 0049 0000 3745</p>
          </div>
          <div class="item">
            <p class="tit">开户名：</p>
            <p class="txt">九龙坡区云知印信息技术服务部</p>
          </div>
          <div class="item">
            <p class="tit">转账凭证：</p>
            <div class="voucher_uploadBox">
              <div class="upload" v-if="pay_period.filename.length < 3">
                <p class="t">
                  点击上传
                  <span style="color: #555; font-size: 10px">最多3张</span>
                </p>
                <input
                  type="file"
                  accept="image/png,image/jpeg,image/gif,image/jpg"
                  class="upBtn"
                  @change="chooseImage($event)"
                />
              </div>
              <div>
                <Tag
                  v-for="(item, index) in pay_period.filename"
                  :key="index"
                  closable
                  @on-close="deleteImage(index)"
                >
                  {{ item }}</Tag
                >
              </div>
            </div>
          </div>
        </div>
        <div class="moneyBox">
          总计：<span style="font-size: 20px; color: #2d8cf0"
            ><span style="font-size: 14px">￥</span>{{ pay_period.totalMoney }}
          </span>
        </div>
        <div class="btn-box">
          <div class="subBtn" v-preventReClick @click="meterPay">立即支付</div>
        </div>
        <span
          v-if="pay_period.pay_type === 3"
          style="color: red; font-size: 12px; margin-left: 8px"
          >凭证提交后，我们将尽快审核，审核通过后功能将自动开通</span
        >
      </div>
    </Modal>

    <Modal
      v-model="payModalStatus"
      title="微信扫码支付"
      width="600"
      :mask-closable="false"
      mask
      cancel-text=" "
      :footer-hide="true"
      style="text-align: center"
    >
      <canvas
        :style="{ height: '260px', width: '260px' }"
        :height="260"
        :width="260"
        ref="qr"
      ></canvas>
      <p style="text-align: center; line-height: 35px; margin-top: 20px">
        支付完成后请手动关闭此弹窗
      </p>
    </Modal>
    <Modal v-model="modalHint" title="重要提示" width="700" :footer-hide="true">
      <div class="important-box">
        <div class="hint">
          面容认证功能目前支持以下型号设备，因此发生的错误操作，损失自行承担！
        </div>
        <div class="title">理光品牌</div>
        <div class="content">
          IMC2000 IMC2500 IMC3000 IMC3500 IMC4500 IMC6000 IMC8000 IMC400F IM430F
        </div>
        <div>以及后续机型</div>
        <div class="title" style="margin-top: 20px">基士得耶品牌</div>
        <div class="content">GS3020C GS3025C GS3030C GS3035C GS3045C GS3060C</div>
        <div>以及后续机型</div>
        <div style="text-align: center">
          <Button
            class="btn"
            type="primary"
            @click="
              modalPay.visible = true;
              modalHint = false;
            "
            >知道了，继续</Button
          >
        </div>
      </div>
    </Modal>
    <Modal
      v-model="modalIdcardAddress"
      title="身份证读取输出功能"
      width="800"
      :footer-hide="true"
    >
      <div class="tips">
        <Icon
          type="md-alert"
          size="20"
          color="#2d8cf0"
          style="margin-right: 10px"
        />请正确填写收货信息，错误操作将无法撤销
      </div>
      <div class="idcard-address-box">
        <div class="hint">
          你所购买的功能包含附件产品，我们将以快递的方式寄送给你，请正确填写收货信息！
        </div>
        <Form
          ref="idcardAddress"
          :model="receivingData"
          :rules="rule"
          style="margin-top: 20px"
          :label-width="90"
        >
          <FormItem prop="name" label="收货人:">
            <Input
              v-model="receivingData.name"
              style="width: 300px"
              placeholder="请输入收货人姓名"
            />
          </FormItem>
          <FormItem prop="tel" label="手机号:">
            <Input
              v-model="receivingData.tel"
              style="width: 300px"
              placeholder="请输入收货人手机号"
            />
          </FormItem>
          <FormItem prop="al" label="收货地址:">
            <div style="display: flex; align-items: center">
              <al-selector
                :gutter="0"
                ref="al"
                style="width: 500px; display: inline-block"
                data-type="name"
                searchable
                v-model="receivingData.al"
                level="2"
              />
              <Input
                style="margin-left: 10px; width: 300px"
                v-model="receivingData.address"
                placeholder="详细地址（请勿重复填入省市区）"
              />
            </div>
          </FormItem>
        </Form>
        <div class="btn-box">
          <Button class="btn" type="primary" @click="confirmAdressInfo">下一步</Button>
          <span
            class="btn2"
            @click="
              modalIdcardAddress = false;
              modalPay.isPay = true;
            "
            >无需寄送</span
          >
        </div>
      </div>
    </Modal>

    <fileCheck
      v-if="showOpenFileCheckModal"
      @cancel="showOpenFileCheckModal = false"
    ></fileCheck>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import qr from 'qr.js'
import fileCheck from './componse/fileCheck.vue'
export default {
  components: { fileCheck },
  data () {
    this.log = {
      1: '12个月设备运维费',
      2: '24个月设备运维费',
      3: '36个月设备运维费',
      4: '刷卡验证',
      5: '身份证自动读取输出功能',
      8: '照片冲印功能'
    }
    return {
      rechargeModel: {
        visible: true,
        data: {}
      },
      company_id: [],
      loadding: false,
      showLoadding: false,
      // company: [],  // 所有企业
      machine: [], // 所有设备
      type: 1, // 1 设备运维配置 2 企业功能配置

      machines: {}, // 选择的设备
      operateMoney: 1200,
      operateLabel: '',

      bag: {},
      data: {
        types: [],
        money: 0,
        pay_type: 2,
        machine_id: [],
        company_id: []
      },

      visible: false,
      modalLog: '',
      file: {},
      filename: '',
      modalMeterPay: {
        visible: false,
        isPay: false,
        pay_type: 2,
        num: 5,
        format: {
          5: 500,
          30: 2400,
          50: 3500,
          100: 5000
        }
      },
      payType: 0, // 购买类型
      payModalStatus: false,
      modalPay: {
        visible: false,
        title: '设备运营期延续',
        machine: [], // 可选择的设备列表
        isPay: false,
        data: {
          select_machine: [], // 下拉选择的设备
          machine: [] // 选择的设备
        }
      },
      pay_period: {
        machine_id: [], // 设备ID
        type: 1,
        month: 12,
        pay_type: 2,
        eduction: 0,
        money: 0,
        oldMoney: 0,
        coupon: 0,
        file: [],
        filename: [],
        monthNumber: 0,
        operateMoney: 1200, // 12个月1200
        totalMoney: 0, // 总金额
        count: 0 // 数量
      },
      itemStyle1: '',
      itemStyle2: '',
      itemStyle3: '',
      itemStyle4: '',
      itemStyle5: '',
      itemStyle6: '',
      itemStyle8: '',
      modalHint: false,
      modalIdcardAddress: false,
      receivingData: {
        name: '',
        tel: '',
        al: [],
        address: ''
      },
      rule: {
        name: [{ required: true, message: '请输入收货人姓名', trigger: 'blur' }],
        tel: [{ required: true, message: '请输入收货人手机号', trigger: 'blur' }],
        al: [
          {
            required: true,
            type: 'array',
            min: 2,
            message: '请选择设备地址',
            trigger: 'blur'
          }
        ],
        address: [{ required: true, message: '请输入设备地址', trigger: 'blur' }]
      },
      machineSn: '',
      showOpenFileCheckModal: false // 该功能隐藏
    }
  },
  mounted () {
    // this.machines = this.$route.query.id?{[]:}:{}
    // console.log(this.agent)
    // this.company_id = this.$route.query.company_id?[parseInt(this.$route.query.company_id)]:[]
    this.type = this.$route.query.type ? parseInt(this.$route.query.type) : 1
    // this.loadding = true;
    /* this.getMachine({
      l: 1000,
      p: 0,
      cond: "id",
      value: "",
      status: -1,
      // senior: `agent_id***0***${this.agent.id}`,
      senior: "", //`agent_id***0***${2}`,//测试用
      key: "id",
      order: "desc",
    }).then((res) => {
      this.machine = res.data;
      if (this.showLoadding) {
        this.initMachineData();
      }
      this.loadding = false;
      this.showLoadding = false;
    }); */
  },
  methods: {
    // 选择功能
    selectType (index) {
      if (this.loadding) {
        this.showLoadding = true
      }
      this.payType = index
      this.initMachineData()
      if (index == 1) {
        // 运营期
        this.pay_period.operateMoney = 1200
        this.modalPay.title = '设备运营期延续'
        this.pay_period.type = 1
        this.pay_period.month = 12
      } else if (index == 2) {
        // 刷卡
        this.modalPay.title = '刷卡验证功能'
        this.pay_period.operateMoney = 500
        this.pay_period.type = 4
      } else if (index == 3) {
        // 身份证
        this.modalPay.title = '身份证读取输出功能'
        this.pay_period.operateMoney = 500
        this.pay_period.type = 5
      } else if (index == 8) {
        console.log('index', index)
        // 照片冲印
        this.modalPay.title = '照片冲印功能'
        this.pay_period.operateMoney = 800
        this.pay_period.type = 8
      } else if (index == 4) {
        // 智能运维
        this.modalMeterPay.visible = true
        this.pay_period.totalMoney = this.modalMeterPay.format[5].toFixed(2)
      } else if (index == 5) {
        // 人脸识别
        this.modalPay.title = '面容认证功能'
        this.pay_period.operateMoney = 1200
        this.pay_period.type = 7
        this.modalPay.visible = false
        this.modalHint = true
      } else if (index == 9) {
        this.showOpenFileCheckModal = true
      }
    },
    initMachineData () {
      this.modalPay.machine = []
      if (this.payType == 1 || this.payType == 2 || this.payType == 8) {
        this.modalPay.visible = true
        this.machine.map((item) => {
          if (item.meter == 0) {
            // 云知印
            this.modalPay.machine.push(item)
          }
        })
      } else if (this.payType == 3 || this.payType == 5) {
        if (this.payType == 3) {
          this.modalPay.visible = true
        }
        this.machine.map((item) => {
          if (item.meter == 0) {
            // 云知印
            this.modalPay.machine.push(item)
          }
        })
      }
    },
    operateMoneyClick (operateMoney, type, operateLabel) {
      this.operateMoney = operateMoney
      this.operateLabel = operateLabel
      if (type <= 3 && (this.bag[1] || this.bag[2] || this.bag[3])) {
        let temp = JSON.parse(JSON.stringify(this.bag))
        delete temp[1]
        delete temp[2]
        delete temp[3]
        temp[type] = { type: type, money: operateMoney }
        this.$set(this, 'bag', temp)
      }
    },

    getBackingStorePixelRatio (ctx) {
      return (
        ctx.webkitBackingStorePixelRatio ||
        ctx.mozBackingStorePixelRatio ||
        ctx.msBackingStorePixelRatio ||
        ctx.oBackingStorePixelRatio ||
        ctx.backingStorePixelRatio ||
        1
      )
    },
    showQrModal (data, name = 'qr') {
      try {
        var $qr = this.$refs[name]
        var qrcode = qr(data)
        var ctx = $qr.getContext('2d')
        var cells = qrcode.modules
        var tileW = 260 / cells.length
        var tileH = 260 / cells.length
        var scale = (window.devicePixelRatio || 1) / this.getBackingStorePixelRatio(ctx)
        $qr.height = $qr.width = 260 * scale
        ctx.scale(scale, scale)
        cells.forEach((row, rdx) => {
          row.forEach((cell, cdx) => {
            ctx.fillStyle = cell ? '#000000' : '#FFFFFF'
            var w = Math.ceil((cdx + 1) * tileW) - Math.floor(cdx * tileW)
            var h = Math.ceil((rdx + 1) * tileH) - Math.floor(rdx * tileH)
            ctx.fillRect(Math.round(cdx * tileW), Math.round(rdx * tileH), w, h)
          })
        })
      } catch (error) {
        console.log(error)
      }
    },

    addSelectMachine () {
      let data = this.modalPay.data
      if (data.select_machine.length == 0) {
        this.$Message.error('请选择设备!')
        return
      }
      if (data.machine.length > 0) {
        let arry = []
        this.modalPay.machine.map((item) => {
          data.select_machine.map((i) => {
            if (item.id == i) {
              arry.push(item)
            }
          })
        })
        data.machine = arry
      } else {
        this.modalPay.machine.map((item) => {
          data.select_machine.map((i) => {
            if (item.id == i) {
              data.machine.push(item)
            }
          })
        })
      }
      data.select_machine = []
    },
    delMachine (data) {
      this.modalPay.data.machine.map((item, index) => {
        if (item.id == data.id) {
          this.modalPay.data.machine.splice(index, 1)
        }
      })
      this.modalPay.data.select_machine.map((item, index) => {
        if (item == data.id) {
          this.modalPay.data.select_machine.splice(index, 1)
        }
      })
    },
    btnNext () {
      let count = this.modalPay.data.machine.length
      if (count == 0) {
        this.$Message.error('请选择设备!')
        return
      }
      console.log('this.modalPay.data.machine', this.modalPay.data.machine)

      // 检查京瓷设备是否选择了不支持的功能
      const unsupportedFeatures = {
        2: '刷卡验证',
        3: '身份证读取',
        5: '面容认证',
        8: '相片冲印'
      }
      for (let item of this.modalPay.data.machine) {
        if (item.machine_brand_name === '京瓷' && unsupportedFeatures[this.payType]) {
          this.$Message.error(`仅支持理光品牌设备开通此功能`)
          return
        }
      }

      let isPay = false,
        sn = ''
      console.log('下一步:', this.modalPay.data.machine)
      console.log('支付参数', this.pay_period)
      this.pay_period.machine_id = []
      this.modalPay.data.machine.map((item) => {
        console.log('item', item, this.payType)
        if (this.payType == 2 && item.functions.indexOf('cardlogin') > -1) {
          isPay = true
          sn = item.sn
        } else if (this.payType == 3 && item.functions.indexOf('idcard') > -1) {
          isPay = true
          sn = item.sn
        } else if (this.payType == 8 && item.functions.indexOf('photo_print') > -1) {
          isPay = true
          sn = item.sn
        } else if (this.payType == 5 && item.functions.indexOf('facelogin') > -1) {
          isPay = true
          sn = item.sn
        }
        this.pay_period.machine_id.push(item.id)
      })
      console.log('设备ID', this.pay_period.machine_id)
      if (isPay) {
        this.$Message.info('设备(' + sn + ')已具备此功能，无需重复购买')
        return
      }
      if (this.payType == 1 || this.payType == 4 || this.payType == 8) {
        // 运营期|智能运维
        this.modalPay.isPay = true
      } else {
        this.modalIdcardAddress = true
      }
      this.pay_period.count = count
      let money = this.pay_period.operateMoney * count
      this.pay_period.totalMoney = money.toFixed(2)
    },
    chooseImage (e) {
      this.pay_period.file.push(e.target.files[0])
      this.pay_period.filename.push(e.target.files[0].name)
    },
    deleteImage (index) {
      this.pay_period.file.splice(index, 1)
      this.pay_period.filename.splice(index, 1)
    },
    // 选择延期月份
    changeMonth () {
      let month = this.pay_period.month
      switch (month) {
        case 12:
          this.pay_period.operateMoney = 1200
          this.pay_period.coupon = ''
          this.pay_period.type = 1
          break
        case 24:
          this.pay_period.operateMoney = 1800
          this.pay_period.coupon = '(省 : 600.00元)'
          this.pay_period.type = 2
          break
        case 36:
          this.pay_period.operateMoney = 2400
          this.pay_period.coupon = '(省 : 1200.00元)'
          this.pay_period.type = 3
          break
      }
      let count = this.modalPay.data.machine.length
      let money = this.pay_period.operateMoney * count
      this.pay_period.totalMoney = money.toFixed(2)
    },
    // 获取支付参数
    payPeriod () {
      let data = {
        types: [],
        money: 0,
        pay_type: this.pay_period.pay_type,
        machine_id: this.pay_period.machine_id
      }
      if (this.payType == 2 || this.payType == 3 || this.payType == 5) {
        // 刷卡、身份证读卡、面容认证
        data.remark =
          this.receivingData.name +
          ' ' +
          this.receivingData.tel +
          ' ' +
          this.receivingData.al +
          this.receivingData.address
      }
      let payData = this.pay_period
      data.types.push(payData.type)
      data.money = payData.totalMoney

      if (data.money > 0) {
        // let data = JSON.parse(JSON.stringify(data));
        data.agent_id = this.agent.id
        if (data.pay_type !== 3) {
          this.BuyIncrement(data).then((res) => {
            if (res.code && res.code === 2) {
              this.$Message.error(res.msg)
              return false
            }
            this.modalPay.visible = false
            this.pay_period = {
              machine_id: [], // 设备ID
              type: 1,
              month: 12,
              pay_type: 2,
              eduction: 0,
              money: 0,
              oldMoney: 0,
              coupon: 0,
              file: [],
              filename: [],
              monthNumber: 0,
              operateMoney: 1200, // 12个月1200
              totalMoney: 0, // 总金额
              count: 0 // 数量
            }
            if (data.pay_type === 1) {
              // 微信支付
              this.payModalStatus = true
              this.showQrModal(res.code_url)
            } else if (data.pay_type === 2) {
              // 支付宝
              window.open(`https://openapi.alipay.com/gateway.do?${res}`)
            }
          })
        } else {
          // 银行转账
          try {
            if (data.pay_type === 3) {
              let formData = new FormData()
              if (payData.file.length > 0) {
                payData.file.map((item) => {
                  formData.append('file', item)
                })
                console.log('支付', formData)
                let ndata = data
                this.TransferIncrement({
                  file: formData,
                  data: ndata
                }).then((res) => {
                  console.log('結果', res)
                  this.modalPay.visible = false
                  if (res) {
                    this.$Message.success('提交成功请等待审核!')
                    this.pay_period = {
                      machine_id: [], // 设备ID
                      type: 1,
                      month: 12,
                      pay_type: 2,
                      eduction: 0,
                      money: 0,
                      oldMoney: 0,
                      coupon: 0,
                      file: [],
                      filename: [],
                      monthNumber: 0,
                      operateMoney: 1200, // 12个月1200
                      totalMoney: 0, // 总金额
                      count: 0 // 数量
                    }
                  }
                })
              } else {
                this.$Message.error('请上传转账凭证')
              }
            } else {
            }
          } catch (error) {}
        }
      }
    },
    modalPayChange (visible) {
      if (!visible) {
        // 隐藏
        this.modalPay.isPay = false
        this.modalPay.data = {
          select_machine: [], // 下拉选择的设备
          machine: [] // 选择的设备
        }
        this.modalMeterPay.isPay = false
        this.pay_period = {
          machine_id: [], // 设备ID
          type: 1,
          month: 12,
          pay_type: 2,
          eduction: 0,
          money: 0,
          oldMoney: 0,
          coupon: 0,
          file: [],
          filename: [],
          monthNumber: 0,
          operateMoney: 1200, // 12个月1200
          totalMoney: 0, // 总金额
          count: 0 // 数量
        }
        this.receivingData = {
          name: '',
          tel: '',
          al: [],
          address: ''
        }
      }
    },
    selectMeter (num) {
      console.log('数量', num)
      this.modalMeterPay.num = num
      this.pay_period.totalMoney = this.modalMeterPay.format[num].toFixed(2)
    },
    nextMeter () {
      if (!this.agent.tp) {
        this.$Message.error('不支持购买')
        return
      }
      this.modalMeterPay.isPay = true
    },
    meterPay () {
      try {
        if (this.pay_period.pay_type !== 3) {
          this.BuyMeterIncrement({
            pay_type: this.pay_period.pay_type,
            num: this.modalMeterPay.num
          }).then((res) => {
            if (res.code && res.code === 2) {
              this.$Message.error(res.msg)
              return false
            }
            this.modalMeterPay.visible = false
            if (this.pay_period.pay_type === 1) {
              this.payModalStatus = true
              this.showQrModal(res.code_url)
            } else if (this.pay_period.pay_type === 2) {
              window.open(`https://openapi.alipay.com/gateway.do?${res}`)
            }
          })
        } else {
          if (this.pay_period.file.length > 0) {
            let formData = new FormData()
            this.pay_period.file.map((item) => {
              formData.append('file', item)
            })
            this.TransferMeterIncrement({
              file: formData,
              data: {
                pay_type: this.pay_period.pay_type,
                num: this.modalMeterPay.num
              }
            }).then((res) => {
              this.modalMeterPay.visible = false
              if (res) {
                this.$Message.success('提交成功请等待审核!')
              }
            })
          } else {
            this.$Message.error('请上传转账凭证')
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 确认身份证读卡功能的配送信息
    confirmAdressInfo () {
      this.$refs.idcardAddress.validate((valid) => {
        if (valid) {
          this.receivingData.al.join('')
          this.modalIdcardAddress = false
          this.modalPay.isPay = true
        }
      })
    },
    getMachineInfo () {
      if (!this.machineSn) {
        this.$Message.error('请输入设备序列号')
        return false
      }
      const sns = this.modalPay.data.machine.map(item => {
        return item.sn
      })
      if (sns.includes(this.machineSn)) {
        this.$Message.error('当前序列号已存在')
        return false
      }

      console.log('支付类型', this.payType)
      this.machineInfo({ sn: this.machineSn }).then((res) => {
        console.log(res)
        if (!res || !res.id) {
          this.$Message.error('设备不存在')
          return false
        }
        if (res.machine_brand_name === '京瓷') {
          this.$Message.error('此设备不支持在线购买运营期!')
          return
        }
        if (this.payType != 3 && this.payType != 5 && res.meter != 0) {
          // 云知印设备
          this.$Message.error('此设备无需购买运营期!')
          return
        } else if (
          this.payType == 5 &&
          res.software_name &&
          res.software_name.indexOf('通用基础版') == -1
        ) {
          this.$Message.error('只支持通用基础版的设备!')
          return
        } else if (
          this.payType == 3 &&
          res.software_name &&
          res.software_name.indexOf('服务窗口版') == -1
        ) {
          this.$Message.error('仅支持理光品牌（服务窗口版）的设备!')
          return
        }
        const payTypes = [2, 3, 5, 8]
        if (res.machine_brand_name === '京瓷' && payTypes.includes(this.payType)) {
          this.$Message.error('仅支持理光品牌设备开通此功能!')
          return
        }

        this.machineSn = ''
        this.modalPay.data.machine.push(res)
      })
    },
    ...mapActions([
      'getCompany',
      'getMachine',
      'BuyIncrement',
      'TransferIncrement',
      'BuyMeterIncrement',
      'TransferMeterIncrement',
      'machineInfo'
    ])
  },
  computed: mapGetters({
    agent: 'agent'
  })
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
